import {
  WSContainer,
  WSFlexBox,
  WSGridCentered,
  WSIcon,
  WSLayout,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";

interface NEC1099FilingContainerProps {
  title: string;
  children: ReactNode;
}

export const NEC1099FilingContainer: React.FC<NEC1099FilingContainerProps> = ({
  title,
  children
}) => {
  useBrowserPageTitle(title);
  const history = useHistory();
  const onSaveAndExit = () => {
    history.push("/member/1099-filing/preview");
  };
  return (
    <WSLayout
      headerLeft={
        <WSFlexBox.CenterY onClick={onSaveAndExit}>
          <WSIcon mr="XS" size="XS" name="chevronLeft" color="grey700" />
          <WSText.Label color="grey600">Save & exit</WSText.Label>
        </WSFlexBox.CenterY>
      }
      title={title}
      line
    >
      <WSContainer verticalPadding>
        <WSGridCentered M={6}>{children}</WSGridCentered>
      </WSContainer>
    </WSLayout>
  );
};
